/**
 * Datamodel bindings: which schema tables and relations the app queries.
 * Part of the persisted "directory" configuration; override via the
 * Configuration screen to point the app at a different EMX2 datamodel.
 *
 * Fixed model contract (NOT configurable, the app relies on these column
 * names existing): id, name, withdrawn, country, the "services" REFBACK on
 * the provider table, the "network" REF_ARRAY, and the contact/head person
 * shapes. Everything else column-related is configurable through the
 * *Columns configuration keys.
 *
 * Defaults target the isidore-acc-v13 model.
 */
export interface IDataModelSearchFields {
  /** Search fields on the provider (root) table, dotted paths allowed. */
  root: string[];
  /** Extra keys are nested ref/refback branch names with their own fields. */
  [branch: string]: string[];
}

export interface IDataModel {
  /** Provider table name; also the GraphQL response key. */
  providerTable: string;
  /** Service table name; also the GraphQL response key. */
  serviceTable: string;
  /** Network table name; also the GraphQL response key. */
  networkTable: string;
  /** Name of the REF on the service table pointing back to its provider. */
  providerRefOnService: string;
  /** Free-text search fields, shaped like QueryEMX2.searchFieldsByProperty. */
  searchFields: IDataModelSearchFields;
}

export const initialDataModel: IDataModel = {
  providerTable: "ServiceProviders",
  serviceTable: "Services",
  networkTable: "Networks",
  providerRefOnService: "service_providers",
  searchFields: {
    root: [
      "id",
      "name",
      "acronym",
      "description",
      "research_infrastructure",
      "services.name",
      "services.acronym",
      "services.description",
      "services.serviceTypes.name",
      "services.serviceTypes.label",
      "services.pathogen",
      "services.unitTheme",
    ],
    services: [
      "id",
      "name",
      "acronym",
      "description",
      "serviceTypes.name",
      "serviceTypes.label",
      "service_providers.research_infrastructure",
      "pathogen",
      "unitTheme",
    ],
  },
};

export default initialDataModel;
